import { InternalAspect } from './type'

export function newInternalAspect(): InternalAspect {
    return {
        id: undefined,
        ceiling_id: null,
        walls_and_partition_id: null,
        floor_type_id: null,
        has_other: false,
        other_aspects: null,

        roof_structure_id: null,
        roof_structure_comment: null,
        ceiling_comment: null,
        walls_and_partition_comment: null,
        floor_type_comment: null,
        fireplaces_chimney_breast_id: null,
        fireplaces_chimney_breast_comment: null,
        bathroom_fitting_ids: null,
        builtin_fitting_ids: null,
        woodwork: null,
        woodwork_comment: null,
        height: null,
        height_comment: null,
        cubic_content: null,
        cubic_content_comment: null,
        storage_type_id: null,
        storage_type_comment: null,
        shop_front_type_id: null,
        shop_front_type_comment: null,
        has_automation: false,
        automations: [],
        above_floors: null,
        below_floors: null,
        state_of_repair_id: null,
        building_facilities_ids: null ,
        windows_id: null,
        windows_comment: null
    }
}